import type { ReactNode } from "react";

export function StateView({
  eyebrow,
  title,
  children,
  action,
}: {
  eyebrow: string;
  title: string;
  children: ReactNode;
  action?: ReactNode;
}) {
  return (
    <main className="state-view">
      <a className="brand" href="/" aria-label="TillFlo Reports home">
        <span>T</span>illFlo
      </a>
      <section>
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <div className="state-copy">{children}</div>
        {action ? <div className="state-actions">{action}</div> : null}
      </section>
    </main>
  );
}
